import type { BorrowMarketAssetData } from '@/utils/internalAppSdk'

function getCollateralTvlUsd(assetData: BorrowMarketAssetData) {
  const tvlUsd = assetData.totalSupplied?.usd
  if (tvlUsd == null) return undefined

  const value = Number(tvlUsd)
  return Number.isFinite(value) ? value : undefined
}

function compareFallback(a: BorrowMarketAssetData, b: BorrowMarketAssetData) {
  const symbolComparison = a.asset.symbol.toLowerCase().localeCompare(b.asset.symbol.toLowerCase())
  if (symbolComparison !== 0) return symbolComparison

  const nameComparison = a.asset.name.toLowerCase().localeCompare(b.asset.name.toLowerCase())
  if (nameComparison !== 0) return nameComparison

  return 0
}

export function sortBorrowMarketCollateralAssets(collateralAssets: BorrowMarketAssetData[]) {
  return [...collateralAssets].sort((a, b) => {
    const aTvlUsd = getCollateralTvlUsd(a)
    const bTvlUsd = getCollateralTvlUsd(b)

    if (aTvlUsd !== undefined && bTvlUsd !== undefined && aTvlUsd !== bTvlUsd) return bTvlUsd - aTvlUsd
    if (aTvlUsd !== undefined && bTvlUsd === undefined) return -1
    if (aTvlUsd === undefined && bTvlUsd !== undefined) return 1

    return compareFallback(a, b)
  })
}
